module.exports = __webpack_public_path__ + "img/nav4h.11ff70cd.png";